import React, { useEffect, useState } from 'react';

// Acceso por PIN a la demo publicada (sesión #6). Pregunta al backend si hay PIN; si no lo hay (local), entra directo.
// El token queda en sessionStorage y se agrega a cada llamada al backend.
const API = process.env.REACT_APP_BACKEND_URL;
const CLAVE = 'mbm-demo-token';

const leer = () => { try { return sessionStorage.getItem(CLAVE) || ''; } catch (e) { return ''; } };
const guardar = (t) => { try { sessionStorage.setItem(CLAVE, t); } catch (e) { /* noop */ } };

const fetchOriginal = window.fetch.bind(window);
window.fetch = (url, opts = {}) => {
  const t = leer();
  if (!t || !String(url).startsWith(`${API}/api`)) return fetchOriginal(url, opts);
  return fetchOriginal(url, { ...opts, headers: { ...(opts.headers || {}), 'X-Demo-Token': t } });
};

export const PinGate = ({ children }) => {
  const [estado, setEstado] = useState(leer() ? 'ok' : 'cargando');
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (estado !== 'cargando') return;
    fetchOriginal(`${API}/api/pin`).then((r) => r.json()).then((r) => setEstado(r.requerido ? 'pedir' : 'ok'))
      .catch(() => setEstado('ok'));
  }, [estado]);

  const entrar = async (e) => {
    e.preventDefault();
    const r = await fetchOriginal(`${API}/api/pin`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pin }),
    }).then((x) => x.json()).catch(() => ({ ok: false }));
    if (r.ok) { guardar(r.token); setEstado('ok'); } else { setError(true); setPin(''); }
  };

  if (estado === 'ok') return children;
  if (estado === 'cargando') return null;
  return (
    <div className="pin-gate" data-testid="pin-gate">
      <form className="pin-card" onSubmit={entrar}>
        <span className="pin-k">MBM Protector · demo</span>
        <h1>Escribe el PIN de acceso</h1>
        <input
          type="password" inputMode="numeric" autoComplete="off" autoFocus value={pin}
          onChange={(e) => { setPin(e.target.value); setError(false); }} aria-label="PIN" data-testid="pin-input"
        />
        {error ? <p className="pin-error" data-testid="pin-error">Ese PIN no es. Inténtalo de nuevo.</p> : null}
        <button type="submit" className="btn-accion" disabled={!pin} data-testid="pin-entrar">Entrar</button>
      </form>
    </div>
  );
};
